import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import SpawnBackground from './SpawnBackground';

/**
 * Homepage for Spawnry
 * Marketing page with hero section, features, and CTAs
 */
const Home = ({ auth }) => {
  const isAuthenticated = auth && auth.id;
  return (
    <>
      <Helmet>
        <title>Spawnry - Your Story, Ready For All Platforms</title>
        <meta name="description" content="Transform any article into audio, social posts, and summaries in seconds. Powered by AI. Built for content teams." />
      </Helmet>

      {/* Hero Section with Animated Background */}
      <section style={{
        position: 'relative',
        minHeight: '90vh',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden'
      }}>
        <SpawnBackground />
        <Container style={{ position: 'relative', zIndex: 1 }}>
          <Row className="align-items-center">
            <Col lg={7}>
              <h1 style={{
                fontSize: 'clamp(2.25rem, 4.5vw, 3.5rem)',
                fontWeight: '700',
                marginBottom: '1.5rem',
                lineHeight: '1.15',
                color: 'white'
              }}>
                Your story,<br />
                ready for all platforms
              </h1>
              <p style={{
                fontSize: '1.25rem',
                marginBottom: '2rem',
                color: 'rgba(255, 255, 255, 0.85)',
                maxWidth: '520px',
                lineHeight: '1.6'
              }}>
                Transform any article into audio, social posts, and summaries in seconds. Powered by AI. Built for content teams.
              </p>
              <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                <Link
                  to={isAuthenticated ? "/dashboard" : "/free"}
                  className="btn btn-lg"
                  style={{
                    fontWeight: '600',
                    padding: '0.875rem 2rem',
                    background: 'white',
                    color: '#1a1a2e',
                    borderRadius: '8px',
                    border: 'none',
                    transition: 'transform 0.2s, box-shadow 0.2s'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 8px 24px rgba(0,0,0,0.3)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }}
                >
                  {isAuthenticated ? "Go to Dashboard" : "Try It Free"}
                </Link>
                <Link
                  to="/contact"
                  className="btn btn-lg"
                  style={{
                    fontWeight: '600',
                    padding: '0.875rem 2rem',
                    background: 'transparent',
                    color: 'white',
                    borderRadius: '8px',
                    border: '2px solid rgba(255,255,255,0.5)',
                    transition: 'all 0.2s'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.borderColor = 'white';
                    e.target.style.background = 'rgba(255,255,255,0.1)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.borderColor = 'rgba(255,255,255,0.5)';
                    e.target.style.background = 'transparent';
                  }}
                >
                  Contact Sales
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Features Section */}
      <section style={{ padding: '100px 0', background: '#fafafa' }}>
        <Container>
          <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
            <h2 style={{
              fontSize: 'clamp(1.75rem, 3vw, 2.5rem)',
              fontWeight: '700',
              color: '#1a1a2e',
              marginBottom: '1rem'
            }}>
              Everything You Need From One Article
            </h2>
            <p style={{ color: '#64748b', fontSize: '1.125rem', maxWidth: '600px', margin: '0 auto' }}>
              Our AI transforms your content into multiple formats, ready for every platform
            </p>
          </div>
          <Row>
            <Col md={6} lg={3} className="mb-4">
              <Card className="h-100 text-center border-0" style={{
                background: 'white',
                borderRadius: '16px',
                boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
                transition: 'transform 0.2s, box-shadow 0.2s'
              }}>
                <Card.Body className="p-4">
                  <div style={{
                    width: '64px',
                    height: '64px',
                    borderRadius: '16px',
                    background: 'linear-gradient(135deg, rgba(99,102,241,0.1) 0%, rgba(139,92,246,0.1) 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 1.25rem'
                  }}>
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="2">
                      <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
                    </svg>
                  </div>
                  <Card.Title style={{ color: '#1a1a2e', fontWeight: '600', marginBottom: '0.75rem' }}>5-Bullet TLDR</Card.Title>
                  <Card.Text style={{ color: '#64748b', fontSize: '0.95rem' }}>
                    Get the key takeaways instantly with AI-generated summaries
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={3} className="mb-4">
              <Card className="h-100 text-center border-0" style={{
                background: 'white',
                borderRadius: '16px',
                boxShadow: '0 4px 24px rgba(0,0,0,0.06)'
              }}>
                <Card.Body className="p-4">
                  <div style={{
                    width: '64px',
                    height: '64px',
                    borderRadius: '16px',
                    background: 'linear-gradient(135deg, rgba(99,102,241,0.1) 0%, rgba(139,92,246,0.1) 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 1.25rem'
                  }}>
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="2">
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                    </svg>
                  </div>
                  <Card.Title style={{ color: '#1a1a2e', fontWeight: '600', marginBottom: '0.75rem' }}>Social Posts</Card.Title>
                  <Card.Text style={{ color: '#64748b', fontSize: '0.95rem' }}>
                    3 unique posts optimized for engagement across platforms
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={3} className="mb-4">
              <Card className="h-100 text-center border-0" style={{
                background: 'white',
                borderRadius: '16px',
                boxShadow: '0 4px 24px rgba(0,0,0,0.06)'
              }}>
                <Card.Body className="p-4">
                  <div style={{
                    width: '64px',
                    height: '64px',
                    borderRadius: '16px',
                    background: 'linear-gradient(135deg, rgba(99,102,241,0.1) 0%, rgba(139,92,246,0.1) 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 1.25rem'
                  }}>
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="2">
                      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                      <circle cx="8.5" cy="8.5" r="1.5"/>
                      <polyline points="21 15 16 10 5 21"/>
                    </svg>
                  </div>
                  <Card.Title style={{ color: '#1a1a2e', fontWeight: '600', marginBottom: '0.75rem' }}>AI Images</Card.Title>
                  <Card.Text style={{ color: '#64748b', fontSize: '0.95rem' }}>
                    Custom-generated images for each social post
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={3} className="mb-4">
              <Card className="h-100 text-center border-0" style={{
                background: 'white',
                borderRadius: '16px',
                boxShadow: '0 4px 24px rgba(0,0,0,0.06)'
              }}>
                <Card.Body className="p-4">
                  <div style={{
                    width: '64px',
                    height: '64px',
                    borderRadius: '16px',
                    background: 'linear-gradient(135deg, rgba(99,102,241,0.1) 0%, rgba(139,92,246,0.1) 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 1.25rem'
                  }}>
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="2">
                      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/>
                      <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"/>
                    </svg>
                  </div>
                  <Card.Title style={{ color: '#1a1a2e', fontWeight: '600', marginBottom: '0.75rem' }}>Audio Summary</Card.Title>
                  <Card.Text style={{ color: '#64748b', fontSize: '0.95rem' }}>
                    AI-generated audio summary of the article
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* How It Works Section */}
      <section style={{ padding: '100px 0', background: 'white' }}>
        <Container>
          <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
            <h2 style={{
              fontSize: 'clamp(1.75rem, 3vw, 2.5rem)',
              fontWeight: '700',
              color: '#1a1a2e',
              marginBottom: '1rem'
            }}>
              How It Works
            </h2>
            <p style={{ color: '#64748b', fontSize: '1.125rem' }}>
              Three simple steps to multiply your content
            </p>
          </div>
          <Row className="align-items-start" style={{ maxWidth: '900px', margin: '0 auto' }}>
            <Col md={4} className="text-center mb-4">
              <div style={{
                width: '72px',
                height: '72px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.75rem',
                fontWeight: '700',
                margin: '0 auto 1.25rem',
                boxShadow: '0 8px 24px rgba(99,102,241,0.3)'
              }}>1</div>
              <h4 style={{ color: '#1a1a2e', fontWeight: '600', marginBottom: '0.75rem' }}>Paste Article URL</h4>
              <p style={{ color: '#64748b', fontSize: '0.95rem' }}>Enter any article URL from supported news sources</p>
            </Col>
            <Col md={4} className="text-center mb-4">
              <div style={{
                width: '72px',
                height: '72px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.75rem',
                fontWeight: '700',
                margin: '0 auto 1.25rem',
                boxShadow: '0 8px 24px rgba(99,102,241,0.3)'
              }}>2</div>
              <h4 style={{ color: '#1a1a2e', fontWeight: '600', marginBottom: '0.75rem' }}>AI Processing</h4>
              <p style={{ color: '#64748b', fontSize: '0.95rem' }}>Our AI analyzes and transforms the content</p>
            </Col>
            <Col md={4} className="text-center mb-4">
              <div style={{
                width: '72px',
                height: '72px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.75rem',
                fontWeight: '700',
                margin: '0 auto 1.25rem',
                boxShadow: '0 8px 24px rgba(99,102,241,0.3)'
              }}>3</div>
              <h4 style={{ color: '#1a1a2e', fontWeight: '600', marginBottom: '0.75rem' }}>Get Your Content</h4>
              <p style={{ color: '#64748b', fontSize: '0.95rem' }}>Download and share across all your platforms</p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Use Cases Section */}
      <section style={{ padding: '100px 0', background: '#fafafa' }}>
        <Container>
          <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
            <h2 style={{
              fontSize: 'clamp(1.75rem, 3vw, 2.5rem)',
              fontWeight: '700',
              color: '#1a1a2e',
              marginBottom: '1rem'
            }}>
              Built For Content Teams
            </h2>
            <p style={{ color: '#64748b', fontSize: '1.125rem', maxWidth: '600px', margin: '0 auto' }}>
              Whether you're a newsroom, marketing team, or content creator, Spawnry helps you do more with less
            </p>
          </div>
          <Row>
            <Col lg={4} className="mb-4">
              <div style={{
                background: 'white',
                borderRadius: '16px',
                padding: '2rem',
                height: '100%',
                boxShadow: '0 4px 24px rgba(0,0,0,0.06)'
              }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '12px',
                  background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '1.25rem'
                }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                  </svg>
                </div>
                <h4 style={{ color: '#1a1a2e', fontWeight: '600', marginBottom: '0.75rem' }}>News & Media</h4>
                <p style={{ color: '#64748b', fontSize: '0.95rem', marginBottom: '1rem' }}>
                  Extend the reach of your journalism. Turn breaking news into shareable social content and audio snippets for on-the-go audiences.
                </p>
                <ul style={{ color: '#64748b', fontSize: '0.9rem', paddingLeft: '1.25rem', margin: 0 }}>
                  <li>Rapid social distribution</li>
                  <li>Audio for podcasts & briefings</li>
                  <li>Consistent brand voice</li>
                </ul>
              </div>
            </Col>
            <Col lg={4} className="mb-4">
              <div style={{
                background: 'white',
                borderRadius: '16px',
                padding: '2rem',
                height: '100%',
                boxShadow: '0 4px 24px rgba(0,0,0,0.06)'
              }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '12px',
                  background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '1.25rem'
                }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                    <path d="M12 20V10"/>
                    <path d="M18 20V4"/>
                    <path d="M6 20v-4"/>
                  </svg>
                </div>
                <h4 style={{ color: '#1a1a2e', fontWeight: '600', marginBottom: '0.75rem' }}>Marketing Teams</h4>
                <p style={{ color: '#64748b', fontSize: '0.95rem', marginBottom: '1rem' }}>
                  Repurpose blog posts and thought leadership into multi-channel campaigns without the manual effort.
                </p>
                <ul style={{ color: '#64748b', fontSize: '0.9rem', paddingLeft: '1.25rem', margin: 0 }}>
                  <li>Scale content production</li>
                  <li>Platform-optimized posts</li>
                  <li>Custom AI imagery</li>
                </ul>
              </div>
            </Col>
            <Col lg={4} className="mb-4">
              <div style={{
                background: 'white',
                borderRadius: '16px',
                padding: '2rem',
                height: '100%',
                boxShadow: '0 4px 24px rgba(0,0,0,0.06)'
              }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '12px',
                  background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '1.25rem'
                }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                    <circle cx="9" cy="7" r="4"/>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                  </svg>
                </div>
                <h4 style={{ color: '#1a1a2e', fontWeight: '600', marginBottom: '0.75rem' }}>Content Creators</h4>
                <p style={{ color: '#64748b', fontSize: '0.95rem', marginBottom: '1rem' }}>
                  Grow your audience across platforms. One piece of content becomes many, each tailored for where it's shared.
                </p>
                <ul style={{ color: '#64748b', fontSize: '0.9rem', paddingLeft: '1.25rem', margin: 0 }}>
                  <li>Cross-platform presence</li>
                  <li>Consistent posting schedule</li>
                  <li>Professional quality output</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Benefits Section */}
      <section style={{ padding: '100px 0', background: 'white' }}>
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <h2 style={{
                fontSize: 'clamp(1.75rem, 3vw, 2.5rem)',
                fontWeight: '700',
                color: '#1a1a2e',
                marginBottom: '1.5rem'
              }}>
                Save Hours Every Week
              </h2>
              <p style={{ color: '#64748b', fontSize: '1.125rem', marginBottom: '2rem', lineHeight: '1.7' }}>
                Content repurposing is tedious. Writing social posts, creating images, extracting quotes,
                formatting for different platforms—it adds up. Spawnry automates the repetitive work so you
                can focus on what matters: creating great content.
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                {[
                  { icon: '⚡', text: 'Process articles in under 60 seconds' },
                  { icon: '🎯', text: 'Platform-optimized outputs every time' },
                  { icon: '🔄', text: 'Consistent quality at any scale' },
                  { icon: '💰', text: 'Reduce content production costs' }
                ].map((item, idx) => (
                  <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                    <span style={{ fontSize: '1.25rem' }}>{item.icon}</span>
                    <span style={{ color: '#1a1a2e', fontWeight: '500' }}>{item.text}</span>
                  </div>
                ))}
              </div>
            </Col>
            <Col lg={6}>
              <div style={{
                background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                borderRadius: '24px',
                padding: '3rem',
                color: 'white',
                textAlign: 'center'
              }}>
                <div style={{ fontSize: '4rem', fontWeight: '700', marginBottom: '0.5rem' }}>10x</div>
                <div style={{ fontSize: '1.25rem', opacity: '0.9', marginBottom: '2rem' }}>
                  Content Output Multiplier
                </div>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '1.5rem',
                  textAlign: 'left'
                }}>
                  <div>
                    <div style={{ fontSize: '2rem', fontWeight: '700' }}>1</div>
                    <div style={{ opacity: '0.85', fontSize: '0.9rem' }}>Article Input</div>
                  </div>
                  <div>
                    <div style={{ fontSize: '2rem', fontWeight: '700' }}>5</div>
                    <div style={{ opacity: '0.85', fontSize: '0.9rem' }}>Bullet Summary</div>
                  </div>
                  <div>
                    <div style={{ fontSize: '2rem', fontWeight: '700' }}>3</div>
                    <div style={{ opacity: '0.85', fontSize: '0.9rem' }}>Social Posts</div>
                  </div>
                  <div>
                    <div style={{ fontSize: '2rem', fontWeight: '700' }}>3</div>
                    <div style={{ opacity: '0.85', fontSize: '0.9rem' }}>AI Images</div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* FAQ Section */}
      <section style={{ padding: '100px 0', background: '#fafafa' }}>
        <Container>
          <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
            <h2 style={{
              fontSize: 'clamp(1.75rem, 3vw, 2.5rem)',
              fontWeight: '700',
              color: '#1a1a2e',
              marginBottom: '1rem'
            }}>
              Frequently Asked Questions
            </h2>
          </div>
          <Row style={{ maxWidth: '800px', margin: '0 auto' }}>
            <Col>
              {[
                {
                  q: 'What types of articles can I process?',
                  a: 'Spawnry works with most publicly accessible news articles and blog posts. We support major news outlets and are continually adding more sources. If a domain isn\'t supported yet, you can submit it for approval.'
                },
                {
                  q: 'How does the AI generate images?',
                  a: 'Our AI analyzes the content and context of each social post to generate relevant, visually appealing images. Each image is unique and created specifically for your content.'
                },
                {
                  q: 'Can I edit the generated content?',
                  a: 'The generated content is provided as a starting point. You can copy, download, and edit any of the outputs to match your exact needs before publishing.'
                },
                {
                  q: 'Do you offer enterprise plans?',
                  a: 'Yes! Contact our sales team to learn about team accounts, higher token allocations, and dedicated support for your organization.'
                },
                {
                  q: 'How do you handle copyright and attribution?',
                  a: 'Spawnry is designed for content creators to repurpose their own content or content they have rights to use. Always ensure you have appropriate rights before processing any article.'
                }
              ].map((faq, idx) => (
                <div key={idx} style={{
                  background: 'white',
                  borderRadius: '12px',
                  padding: '1.5rem',
                  marginBottom: '1rem',
                  boxShadow: '0 2px 12px rgba(0,0,0,0.04)'
                }}>
                  <h4 style={{ color: '#1a1a2e', fontWeight: '600', marginBottom: '0.75rem', fontSize: '1.1rem' }}>
                    {faq.q}
                  </h4>
                  <p style={{ color: '#64748b', margin: 0, lineHeight: '1.6' }}>
                    {faq.a}
                  </p>
                </div>
              ))}
            </Col>
          </Row>
        </Container>
      </section>

    </>
  );
};

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(Home);
